import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import NotificationBell from '@icon/NotificationBell';
import { mediaQuery, Spacings } from '@styles/index';
import { useState } from 'react';
import Button from 'aquilla/core/molecules/Button';
import { segment } from '@actions/analytics';
import { evtNameCategoryMap } from '@constants/index';
import { BATCH_UPDATE, BATCH_KEYS } from '@constants/segment';
import useGoalEventProps from '@hooks/useGoalEventProps';
import useAllTypesOfCourseEventProps from '@hooks/useAllTypesOfCourseEventProps';
import useBatchDetails from '@api/hooks/batch/useBatchDetails';
import { useIsMobile } from '@stores/AppCommonData';
import IconButton from 'aquilla/core/molecules/IconButton';
import BatchUpdates from './BatchUpdates';

const StyledShareIcon = styled(NotificationBell)`
  margin-bottom: -${Spacings.SPACING_1B};
`;

const StyledButton = styled(Button)`
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;
const UpdatesButton = ({ batchUID, isIconButton = false }) => {
  const { batchDetails: batch } = useBatchDetails(batchUID);
  const [showUpdates, setShowUpdates] = useState(false);
  const closeUpdatesDrawer = () => setShowUpdates(false);
  const batchGoalUID = batch?.goal?.uid;
  const isMobile = useIsMobile();

  const goalSegmentData = useGoalEventProps({ goalUID: batchGoalUID });
  const segmentData = useAllTypesOfCourseEventProps({
    course: batch,
    isBatch: true
  });

  const openUpdatesDrawer = () => {
    setShowUpdates(true);
    segment.track(
      BATCH_UPDATE,
      {
        ...goalSegmentData,
        ...segmentData
      },
      evtNameCategoryMap.WITHOUT_CATEGORY,
      true,
      BATCH_KEYS
    );
  };

  return (
    <>
      {isIconButton && !isMobile ? (
        <IconButton
          variant="secondary"
          color="white"
          size="medium"
          onClick={openUpdatesDrawer}
          isIconButton
        >
          <NotificationBell
            size={Spacings.SPACING_6B}
            color="var(--color-text-primary)"
          />
        </IconButton>
      ) : (
        <StyledButton
          variant="secondary"
          startIcon={
            <StyledShareIcon
              size={Spacings.SPACING_5B}
              color="var(--color-text-primary)"
            />
          }
          onClick={openUpdatesDrawer}
          size="medium"
          $fullWidth
        >
          Updates
        </StyledButton>
      )}

      <BatchUpdates
        channelId={batch?.channel?.uid}
        batchId={batch?.uid}
        showUpdates={showUpdates}
        onCloseUpdates={closeUpdatesDrawer}
      />
    </>
  );
};

export default UpdatesButton;

UpdatesButton.propTypes = {
  batchUID: PropTypes.string.isRequired
};
